import { defineMessages } from 'utils/intl';

export default defineMessages({
  compare: 'Porównanie',
});
